import React, { useState, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import { ReactComponent as AddPlaylistIcon } from "../../../assets/Icons/addtoplaylist.svg";
import ListView from "./ListView";
import Translate from "../../../Components/Multilanguage/Translate";

const MonthlyView = ({
  events,
  date,
  onDateChange,
  onDeleteVideo,
  onVideoComplete,
  appInfo,
  setShowAddVideoModal,
  user,
  redirectToLogin,
  loading,
}) => {
  const [selectedDate, setSelectedDate] = useState(date);
  const [calendarKey, setCalendarKey] = useState(
    date.getMonth() + "-" + date.getFullYear()
  );

  useEffect(() => {
    setSelectedDate(date);
    setCalendarKey(date.getMonth() + "-" + date.getFullYear());
  }, [date]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
    onDateChange(date);
  };

  const getEventsForDate = (date) => {
    if (!events) return [];

    return events.filter((event) => {
      if (!event || !event.start) return false;

      const eventDate = new Date(event.start);
      return (
        eventDate.getDate() === date.getDate() &&
        eventDate.getMonth() === date.getMonth() &&
        eventDate.getFullYear() === date.getFullYear()
      );
    });
  };

  const tileContent = ({ date, view }) => {
    if (view === "month") {
      const dayEvents = getEventsForDate(date);
      if (dayEvents.length === 0) return null;

      return (
        <div className="dots-container">
          {dayEvents.map((event, index) => (
            <span
              key={index}
              className={`dot ${event.completed ? "completed" : ""}`}
            ></span>
          ))}
        </div>
      );
    }
    return null;
  };

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return (
    <div className="monthly-view-container">
      <div className="calendar-section">
        <Calendar
          key={calendarKey}
          value={selectedDate}
          onChange={handleDateChange}
          tileContent={tileContent}
          showNavigation={false}
          locale="en-US"
          tileClassName={({ date, view }) => {
            if (view === "month") {
              const currentMonth = selectedDate.getMonth();
              const day = date.getDay();
              const hasEvents = getEventsForDate(date).length > 0;

              let className = "";

              if (
                date.getMonth() === currentMonth &&
                (day === 0 || day === 6)
              ) {
                className += "holiday ";
              }

              if (hasEvents) {
                className += "has-events ";
              }

              return className.trim() || null;
            }
            return null;
          }}
        />
      </div>
      {
        date.setHours(0, 0, 0, 0) >= today.getTime() && (
          <button
          className="add-video-btn"
          onClick={() => {
            if (!user) {
              redirectToLogin();
            } else {
              setShowAddVideoModal(true);
            }
          }}
        >
          <AddPlaylistIcon /> <Translate textKey={"add_video"} />
        </button>
        )
      }
      <div className="list-section">
        <ListView
          events={getEventsForDate(selectedDate)}
          date={selectedDate}
          calendarView={true}
          onDeleteVideo={onDeleteVideo}
          onVideoComplete={onVideoComplete}
          appInfo={appInfo}
          user={user}
          redirectToLogin={redirectToLogin}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default MonthlyView;
